import './ConjugationTable.css';
import ConjugationTableColumn from './ConjugationTableColumn';

const TENSE_MAPPING = {
  "Indicative": {
    "Present": {
      "label": "Present",
    },
    "Imperfect": {
      "label": "Imperfect",
    },
    "Preterite": {
      "label": "Preterite",
    },
    "Future": {
      "label": "Future",
    },
    "Conditional": {
      "label": "Conditional",
    },
    "Present Perfect": {
      "label": "Present Perfect",
    },
    "Past Perfect": {
      "label": "Past Perfect",
    },
    "Future Perfect": {
      "label": "Future Perfect",
    },
    "Conditional Perfect": {
      "label": "Conditional Perfect",
    },
    "Preterite (Archaic)": {
      "label": "Preterite (Archaic)",
    }
  },
  "Subjunctive": {
    "Present": {
      "label": "Present",
    },
    "Imperfect": {
      "label": "Imperfect",
    },
    "Future": {
      "label": "Future",
    },
    "Present Perfect": {
      "label": "Present Perfect",
    },
    "Past Perfect": {
      "label": "Past Perfect",
    },
    "Future Perfect": {
      "label": "Future Perfect",
    }
  },
  "Imperative Affirmative": {
    "Present": {
      "label": "Affirmative",
    }
  },
  "Imperative Negative": {
    "Present": {
      "label": "Negative",
    }
  }
}

function ConjugationTable(props) {
  const { conjugation } = props;

  // const [presentIsChecked, setPresentIsChecked] = useState(true);
  // const [pastIsChecked, setPastIsChecked] = useState(true);
  // const [futureIsChecked, setFutureIsChecked] = useState(true);
  // const [conditionalIsChecked, setConditionalIsChecked] = useState(true);
  // const [subjunctiveIsChecked, setSubjunctiveIsChecked] = useState(true);

  // const getTensesToShow = () => {
  //   let tensesToShow = [];
  //   if (presentIsChecked) {
  //     tensesToShow.push({
  //       "mood": "Indicative",
  //       "tense": "Present",
  //     })
  //   }
  //   if (pastIsChecked) {
  //     tensesToShow.push({
  //       "mood": "Indicative",
  //       "tense": "Preterite",
  //     })
  //   }
  //   if (futureIsChecked) {
  //     tensesToShow.push({
  //       "mood": "Indicative",
  //       "tense": "Future",
  //     })
  //   }
  //   if (conditionalIsChecked) {
  //     tensesToShow.push({
  //       "mood": "Indicative",
  //       "tense": "Conditional",
  //     })
  //   }
  //   if (subjunctiveIsChecked) {
  //     tensesToShow.push({
  //       "mood": "Subjunctive",
  //       "tense": "Present",
  //     })
  //   }
  //   return tensesToShow;
  // }

  const generateSubjectPronounColumn = () => {
    return (
      <ConjugationTableColumn
        elements=
        {
          [
            {
              "textContent": "Pronoun",
              "isColHeader": true,
            },
            {
              "textContent": "yo",
              "isRowHeader": true,
            },
            {
              "textContent": "tú/vos",
              "isRowHeader": true,
            },
            {
              "textContent": "él/ella/usted",
              "isRowHeader": true,
            },
            {
              "textContent": "nosotros/nosotras",
              "isRowHeader": true,
            },
            {
              "textContent": "vosotros/vosotras",
              "isRowHeader": true,
            },
            {
              "textContent": "ellos/ellas/ustedes",
              "isRowHeader": true,
            },
          ]
        }
      />
    );
  }

  const generateColumn = (tense) => {
    return (
      <ConjugationTableColumn elements={
        [
          {
            "textContent": TENSE_MAPPING[tense["mood"]][tense["tense"]]["label"],
            "isColHeader": true,
          },
          ...[
            "yo",
            "tú/vos",
            "él/ella/usted",
            "nosotros/nosotras",
            "vosotros/vosotras",
            "ellos/ellas/ustedes",
          ].map((pronoun) => {
            return {
              "textContent": conjugation.conjugations[tense["mood"]][tense["tense"]][pronoun],
            }
          }),
        ]
      }/>
    );
  }

  return (
    <div className="conjugation-table">
      <div className="conjugation-table__header">
        <div className="conjugation-table__title">
          <h2>{props.title}</h2>
        </div>
        <div className="conjugation-table__buttons">
          {/* <TenseCheckBox
            text="present tense"
            isChecked={presentIsChecked}
            setIsChecked={setPresentIsChecked}
          />
          <TenseCheckBox
            text="past tense"
            isChecked={pastIsChecked}
            setIsChecked={setPastIsChecked}
          />
          <TenseCheckBox
            text="future tense"
            isChecked={futureIsChecked}
            setIsChecked={setFutureIsChecked}
          />
          <TenseCheckBox
            text="conditional tense"
            isChecked={conditionalIsChecked}
            setIsChecked={setConditionalIsChecked}
          />
          <TenseCheckBox
            text="subjunctive tense"
            isChecked={subjunctiveIsChecked}
            setIsChecked={setSubjunctiveIsChecked}
          /> */}
        </div>
      </div>
      <div className="conjugation-table__content">
        {generateSubjectPronounColumn()}
        {props.tensesToShow.map((tense) => {
          return generateColumn(tense);
        })}
      </div>
    </div>
  )
}

export default ConjugationTable;
